import { Button } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import { ReactElement, useState } from "react";
import { Icon, List, ListElement, SpinnerLegacy } from "../../../components";
import { ErrorMessage } from "../../../components/errorMessage/ErrorMessage";
import { NavigationBarMenu } from "../../../components/navigation/NavigationBar";
import { PRICE_TIER } from "../../../constants/routes";
import { useParamAsNumber } from "../../../hooks/useParamAsNumber";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { usePriceTierList } from "../../../hooks/api/v2/priceTier/usePriceTierList";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { generatePriceTierOrderRuleDescription } from "../../../utils/sellarHelpers";
import { PriceTierDialogCreate } from "../priceTier/dialogs/PriceTierDialogCreate";
import { useRemoteFeatureFlags } from "../../../hooks/useRemoteFeatureFlags";

export function PriceTiers(): ReactElement {
  const { business } = useSellarCurrentBusiness();
  const priceTierId = useParamAsNumber(PRICE_TIER, "priceTierId", false);

  const priceTiersListQuery = usePriceTierList({});

  const [priceTierCreateDialogActive, setPriceTierCreateDialogActive] =
    useState(false);

  const unbundlingRelease2aEnabled = useRemoteFeatureFlags().isActive(
    "unbundlingRelease2A",
  );

  return (
    <>
      <NavigationBarMenu
        title={"Price Tiers"}
        rightComponent={
          <Button
            size={"small"}
            onClick={() => setPriceTierCreateDialogActive(true)}
          >
            <Icon icon={"PLUS"} />
            New
          </Button>
        }
      />
      {priceTiersListQuery.isLoading ? (
        <SpinnerLegacy />
      ) : priceTiersListQuery.isError ? (
        <ErrorMessage>
          {apiV2AssertError(priceTiersListQuery.error)?.response?.data
            .message ?? "Unknown error occurred"}
        </ErrorMessage>
      ) : (
        <div>
          <List className="mx-auto">
            {priceTiersListQuery.data?.pages[0]?.map((priceTier, i) => (
              <ListElement
                promptText={"See details"}
                key={i}
                to={PRICE_TIER.href({ priceTierId: priceTier.id })}
                selected={priceTier.id === priceTierId}
              >
                <div>
                  <div>
                    <b>{priceTier.name}</b>
                  </div>
                  <br />
                  <div>{priceTier.PriceTierDiscounts.length} discounts</div>
                  {priceTier.PriceTierOrderRules.length &&
                  !unbundlingRelease2aEnabled ? (
                    <div>
                      <i>Minimum order quantity rules: </i>
                      <br />
                      {priceTier.PriceTierOrderRules.map((rule) => (
                        <div key={rule.id}>
                          {generatePriceTierOrderRuleDescription(rule)}
                        </div>
                      ))}{" "}
                    </div>
                  ) : null}
                  {priceTier.minimumOrderPrice &&
                  !unbundlingRelease2aEnabled ? (
                    <div>
                      {formatCurrency(
                        priceTier.minimumOrderPrice,
                        business?.Supplier?.currency,
                      )}{" "}
                      minimum order size
                    </div>
                  ) : null}
                </div>
              </ListElement>
            ))}
          </List>
          <PriceTierDialogCreate
            active={priceTierCreateDialogActive}
            onDismiss={() => setPriceTierCreateDialogActive(false)}
          />
        </div>
      )}
    </>
  );
}
